import { getCookie } from '@lhb/cache';
import { isNotEmpty } from '@lhb/func';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { ignoreErrors } from 'src/common/ignore/sentryError';

/** 初始化 sentry
 * @demo 主动提报错误示例 Sentry.captureException(new Error('主动提报错误'));
 */
export const initSentry = () => {
  // 接入sentry，预演、线上环境接入
  if (process.env.NODE_ENV === 'production' && process.env.SENTRY_DSN) {
    if (process.env.CLOSE_SENTRY !== 'yes') { // 定制化项目打包时入参，可以停掉sentry
      // https://docs.sentry.io/platforms/javascript/configuration/options/
      Sentry.init({
        dsn: process.env.SENTRY_DSN,
        environment: process.env.NODE_ENV,
        release: 'area-insight@' + process.env.xClientVersion,
        integrations: [
          new BrowserTracing({
            tracePropagationTargets: ['localhost', 'my-site-url.com', /^\//],
          }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        // 忽略无意义的错误
        ignoreErrors,
        beforeSend(event: any) {
          // console.log(`event`, event);
          // 如果 ignoreErrors 生效，不会走到这里，这里做兜底
          const eventExceptionMessage = Array.isArray(event.exception?.values) && event.exception?.values.length ? event.exception?.values?.[0]?.value : '';
          if (eventExceptionMessage && ignoreErrors.some(pattern => eventExceptionMessage.match(pattern))) {
            return null; // 返回null表示忽略该错误事件
          }
          // 排除依赖包本身的报错
          if (event.location && event.location.match(/\/node_modules\//gi)) {
            return null;
          }
          // 排除地图本身的报错
          if (event.location && event.location.match(/https:\/\/webapi\.amap\.com/gi)) {
            return null;
          }
          // 排除静态资源包的报错
          if (event.location && event.location.match(/https:\/\/staticres\.linhuiba\.com\/libs/gi)) {
            return null;
          }

          // console.log(`hint`, hint);
          // const kunlunUserId = getCookie('kunlun_user_id');
          // const kunlunTK = getCookie('kunlun_token');
          // if (event && event.extra) {
          //   event.extra.userInfo = {
          //     kunlunUserId,
          //     // 上报的是token，这里不用token是因为sentry把token当成了关键词，会把一切包含于token的转换为不可见的字符
          //     kunlunTK,
          //     des: '为方便前端快速排查问题，额外上报的信息',
          //   };
          // }

          const tenantId = getCookie('TENANT_ID');
          const employeeId = getCookie('EMPLOYEE_ID');
          // UIMS_TOKEN是原生写入的，flow_token则是各种来源(原生桥接获取后写入、不同项目跳转)
          const user = getCookie('insightToken');

          if (!isNotEmpty(event.extra)) {
            event.extra = {};
          }
          event.extra.location = event.location; // 看看上面的 location 匹配是否生效
          event.extra.customizedProject = process.env.CUSTOMIZED_PROJECT;
          event.extra.userInfo = {
            tenantId,
            employeeId,
            // 上报的是token，这里不用token是因为sentry把token当成了关键词，会把一切包含于token的转换为不可见的字符
            user,
            des: '为方便前端快速排查问题，额外上报的信息',
          };

          return event;
          // return null 会将此次上报丢弃
        }
      });
    }
  }
};
